import { render, staticRenderFns } from "./NotesFileComponent.vue?vue&type=template&id=20ad8273&"
import script from "./NotesFileComponent.vue?vue&type=script&lang=js&"
export * from "./NotesFileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports